import {
  RESPONSIVE_BREAKPOINT_MOBILE,
  RESPONSIVE_BREAKPOINT_TABLET,
} from "@recare/core/consts";
import { BORDER_BOTTOM, WHITE } from "ds/materials/colors";
import {
  border,
  dp,
  margin as marginMetric,
  sizing,
} from "ds/materials/metrics";
import {
  FONT_SIZE_15,
  FONT_SIZE_20,
  Subheading,
} from "ds/materials/typography";
import styled from "styled-components";

const shadow =
  "0px 1px 1px rgba(0, 0, 0, 0.24), 0px 1px 1.5px rgba(0, 0, 0, 0.22)";
const ContentWrapper = styled.div<{
  breakpointMobile?: boolean;
  margin?: string;
  noShadow?: boolean;
  width?: string;
}>`
  display: flex;
  position: relative;
  height: fit-content;
  width: ${(props) => props.width || sizing(60)};
  justify-content: center;
  flex-direction: column;
  box-shadow: ${({ noShadow }) => (noShadow ? "none" : shadow)};
  border-radius: 10px;
  margin: ${(props) => props.margin || marginMetric(0)};
  @media screen and (max-width: ${(props) =>
      dp(
        props.breakpointMobile
          ? RESPONSIVE_BREAKPOINT_MOBILE
          : RESPONSIVE_BREAKPOINT_TABLET,
      )}) {
    & {
      width: 100vw;
    }
  }
`;

const Title = styled(Subheading)`
  margin: ${marginMetric(2, 0, 0, 3)};
  padding-left: ${sizing(2)};
`;

const CardWrapper = styled.div<{
  breakpointMobile?: boolean;
  margin?: string;
  noShadow?: boolean;
  width?: string;
  withBorder?: boolean;
}>`
  display: flex;
  background-color: ${WHITE};
  position: relative;
  width: ${(props) => props.width || sizing(62)};
  max-width: 100%;
  height: fit-content;
  justify-content: center;
  flex-direction: column;
  margin: ${(props) => props.margin || marginMetric(0)};
  border-bottom: ${({ withBorder }) =>
    withBorder ? border({ color: BORDER_BOTTOM }) : "none"};
  box-shadow: ${({ noShadow }) =>
    noShadow ? "none" : "0px 4px 16px rgba(0, 0, 0, 0.04)"};
  @media screen and (max-width: ${(props) =>
      dp(
        props.breakpointMobile
          ? RESPONSIVE_BREAKPOINT_MOBILE
          : RESPONSIVE_BREAKPOINT_TABLET,
      )}) {
    & {
      width: 100vw;
      margin: ${marginMetric(0)};
    }
  }
`;

const Header = styled(Subheading)<{ breakpointMobile?: boolean }>`
  margin: ${marginMetric(4, 0, 0, 5)};
  font-size: ${FONT_SIZE_20};
  @media screen and (max-width: ${(breakpointMobile) =>
      dp(
        breakpointMobile
          ? RESPONSIVE_BREAKPOINT_MOBILE
          : RESPONSIVE_BREAKPOINT_TABLET,
      )}) {
    & {
      font-size: ${FONT_SIZE_15};
      margin: ${marginMetric(2, 0, 0, 0)};
      padding-left: ${sizing(2)};
    }
  }
`;

const ChildrenWrapper = styled.div<AnyObject>`
  margin: ${({ margin }) => margin || marginMetric(2, 5)};
  display: flex;
  max-width: 100%;
  flex-direction: column;
  @media screen and (max-width: ${(breakpointMobile) =>
      dp(
        breakpointMobile
          ? RESPONSIVE_BREAKPOINT_MOBILE
          : RESPONSIVE_BREAKPOINT_TABLET,
      )}) {
    & {
      margin: ${marginMetric(2)};
    }
  }
`;

export default function RoundCard({
  breakpointMobile,
  children,
  childrenMargin,
  margin,
  nonRound,
  noShadow,
  testId,
  title,
  width,
  withBorder,
}: {
  breakpointMobile?: boolean;
  children: React.ReactNode;
  childrenMargin?: string;
  margin?: string;
  noShadow?: boolean;
  nonRound?: boolean;
  testId?: string;
  title?: string;
  width?: string;
  withBorder?: boolean;
}) {
  if (nonRound) {
    return (
      <CardWrapper
        data-testid={testId}
        breakpointMobile={breakpointMobile}
        margin={margin}
        noShadow={noShadow}
        width={width}
        withBorder={withBorder}
      >
        {title && (
          <Header bold breakpointMobile={breakpointMobile}>
            {title}
          </Header>
        )}
        <ChildrenWrapper
          breakpointMobile={breakpointMobile}
          margin={childrenMargin}
        >
          {children}
        </ChildrenWrapper>
      </CardWrapper>
    );
  }
  return (
    <ContentWrapper
      breakpointMobile={breakpointMobile}
      margin={margin}
      noShadow={noShadow}
      width={width}
    >
      {title && <Title bold>{title}</Title>}
      <ChildrenWrapper
        breakpointMobile={breakpointMobile}
        margin={childrenMargin}
      >
        {children}
      </ChildrenWrapper>
    </ContentWrapper>
  );
}
